/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Responsibleusergroup2Inputs */

const de_entity_responsibleusergroup2 = /** @type {(inputs: Entity_Responsibleusergroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verantwortliche Benutzergruppe`)
};

/** @type {(inputs: Entity_Responsibleusergroup2Inputs) => LocalizedString} */
const en_entity_responsibleusergroup2 = de_entity_responsibleusergroup2;

/**

* @param {Entity_Responsibleusergroup2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_responsibleusergroup2 = /** @type {((inputs?: Entity_Responsibleusergroup2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Responsibleusergroup2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_responsibleusergroup2(inputs)
	return de_entity_responsibleusergroup2(inputs)
});
export { entity_responsibleusergroup2 as "entity_responsibleUserGroup" }